module.exports = __webpack_public_path__ + "static/media/upd_logo.46a96672.svg";